<mat-form-field appearance="outline" *ngIf="control">
  <mat-label *ngIf="label">{{label}}</mat-label>
  <input matInput type="password" [formControl]="control" [type]="hide ? 'password' : 'text'" [placeholder]="label">
  <div matSuffix>
    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
  </div>
  <mat-error *ngIf="control.hasError('required')">{{ 'login.error.password.required' | translate }}</mat-error>
</mat-form-field>
